import axios from 'axios';
import { updateAuth } from 'redux/actions/auth';
import { apiURL } from 'config';

// We inject the Redux store from the App at runtime to avoid circular imports.
let appStore;

export const setAxiosStore = storeInstance => {
  appStore = storeInstance;
};

export function getStore() {
  if (!appStore) {
    // In tests or very early startup, we may not have a store yet.
    // Returning a dummy object avoids crashes; requests made before store is set
    // simply won't add auth headers or dispatch refresh actions.
    return {
      getState: () => ({ auth: {}, app: {} }),
      dispatch: () => {},
    };
  }
  return appStore;
}

axios.defaults.baseURL = apiURL;

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    const { tokenType, accessToken, loggedIn } = getStore().getState().auth;
    const token = `${tokenType} ${accessToken}`;
    if (loggedIn) {
      config.headers['Authorization'] = token;
    }
    // Let browser set Content-Type (with boundary) for FormData
    if (!(config.data && config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

//Add a response interceptor

axios.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    const originalRequest = error.config;

    // Handle 401 errors for authentication
    if (error.response && error.response.status === 401) {
      if (
        originalRequest.url === `/auth/admin-signin` ||
        originalRequest.url === `/auth/admin-refresh-token`
      ) {
        return Promise.reject(error);
      }

      if (!originalRequest._retry) {
        originalRequest._retry = true;
        const { refreshToken, email } = getStore().getState().auth;
        return axios
          .post('/auth/admin-refresh-token', {
            email,
            refreshToken,
          })
          .then(response => {
            const { data: res } = response;
            if (res.code === 200) {
              getStore().dispatch(updateAuth({ ...res.token }));
              const { tokenType, accessToken } = res.token;
              axios.defaults.headers.common[
                'Authorization'
              ] = `${tokenType} ${accessToken}`;
              return axios(originalRequest);
            }
          });
      }
    }
    
    return Promise.reject(error);
  },
);

export default axios;
